import React from 'react';
import PropTypes from 'prop-types';

import styles from './EventListingsPhotoPreview.module.scss';
import TrashCan from '../../../../common/icons/TrashCan';

const EventListingsPhotoPreview = ({ value = null, onChange }) => {
  const getPhotoThumbnail = () => {
    // If the value is a file, create a URL for the image
    if (value instanceof File) {
      return URL.createObjectURL(value);
    }
    // otherwise, return the value as is
    return value;
  };

  let filename = '';
  if (value) {
    if (value instanceof File) {
      filename = value.name;
    } else {
      filename = value.split('/').pop();
    }
  }

  /**
  * Helper function to transform file size in bytes to human readable file size
  * @param {number} fileSize - The file size in bytes
  * @returns {string} – The human readable file size
  */
  const readableFileSize = (fileSize) => {
    const fileSizeInBytes = fileSize ?? 0;
    const sizeInKb = fileSizeInBytes / 1024;

    if (sizeInKb > 1024) return `${(sizeInKb / 1024).toFixed(2)} MB`;
    return `${sizeInKb.toFixed(0)} KB`;
  };

  const handleRemovingPhoto = () => {
    if (typeof value === 'string') onChange({ target: { name: 'deletePhoto', value: true } });
    onChange({ target: { name: 'photo', value: null } });
  };

  return (
    <div className={styles.container}>
      <div className={styles.preview}>
        <div className={styles.preview__container}>
          <div className={styles.thumbnail}>
            <img alt="preview" src={getPhotoThumbnail()} />
          </div>
          <div className={styles['details-container']}>
            <div className={styles.preview__details}>
              <p className={styles.preview__details__label}>
                File name: <span className={styles.preview__details__value}>{filename}</span>
              </p>
              <p className={styles.preview__details__label}>
                Size:{' '}
                <span className={styles.preview__details__value}>
                  {readableFileSize(value.size)}
                </span>
              </p>
            </div>

            <button
              type="button"
              className={styles.delete}
              onClick={() => handleRemovingPhoto()}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleRemovingPhoto();
                }
              }}
              aria-label={`Delete ${filename}`}
              tabIndex="0"
            >
              <TrashCan />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

EventListingsPhotoPreview.propTypes = {
  value: PropTypes.oneOfType([PropTypes.instanceOf(File), PropTypes.string]),
  onChange: PropTypes.func.isRequired,
};

export default EventListingsPhotoPreview;
